import { Budget } from "@interfaces/budget-response";
import { Certificate } from "@interfaces/certificate";
import { NfCompany } from "@interfaces/company-nf";
import { PNCompany } from "@interfaces/pn-company";
import { Usage } from "@interfaces/usage";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const UserActions = createActionGroup({
  source: "User",
  events: {
    "Load Token": props<{
      token: string;
    }>(),
    "Load NF Company": props<{
      company: NfCompany;
    }>(),
    "Load PN Company": props<{
      company: PNCompany;
    }>(),
    "Load Certificate": props<{
      certificate: Certificate;
    }>(),
    "Load Budgets": props<{
      page: number;
      budgets: Budget[];
    }>(),
    "Enable Issues": emptyProps(),
    "Load Limits": props<{
      limits: Usage;
    }>()
  }
});
